var map = {
	"./ContactDetails": "SjO7",
	"./ContactDetails.js": "SjO7",
	"./permanent-residence/Intro1": "uGkq",
	"./permanent-residence/Intro1.js": "uGkq",
	"./permanent-residence/Intro2": "xRUQ",
	"./permanent-residence/Intro2.js": "xRUQ",
	"./permanent-residence/Intro3": "xG2a",
	"./permanent-residence/Intro3.js": "xG2a",
	"./settled-status/Intro1": "S6bE",
	"./settled-status/Intro1.js": "S6bE",
	"./settled-status/Intro2": "qe2H",
	"./settled-status/Intro2.js": "qe2H",
	"./settled-status/Intro3": "TFZZ",
	"./settled-status/Intro3.js": "TFZZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wYRK";